import React, { Component } from 'react'
import './SignUpMembers.css'
import UIkit from 'uikit'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import SignUpMembersForm from './SignUpMembersForm'
import { connect } from 'react-redux'
import * as serializeJavascript from '../../utils/helpers/serializeJavascript'
import { fetchSignUpMembersAction } from '../../actions/Authentification/SignUpMembers'

class SignUpMembers extends Component {
  state = {
    notificationSignUpMembersError: false,
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Inscription`
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.signUpMembers.isError !== this.props.signUpMembers.isError) {
      this.setState({notificationSignUpMembersError: nextProps.signUpMembers.isError})
    }
  }
  handleSubmitSignUpMembers = (FormValues) => {
    const { createAccount } = this.props

    if (Object.keys(FormValues).length !== 0) {
      delete FormValues.passwordFirst
      FormValues["type"] = "members"

      let retrievedApsBeninParrainUserCode = JSON.parse(localStorage.getItem('ApsBeninParentCodeStorage'))
      if (retrievedApsBeninParrainUserCode) { //s'il est venu par le lien d'un parrain
        FormValues["parentCode"] = retrievedApsBeninParrainUserCode
      }
      createAccount(serializeJavascript.sanitize(FormValues))
    }
  }

  NotificationSignUpMembersError = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur lors de l'inscription",
      status: 'danger',
      pos: 'top-center',
    })
    this.setState({ notificationSignUpMembersError: false })
  }

  render() {
    const { signUpMembers } = this.props
    const { notificationSignUpMembersError } = this.state
    return (
      <div>
        <Header userIsSuccessLogin={false} />
          <SignUpMembersForm onSubmit={this.handleSubmitSignUpMembers} signUpMembers={signUpMembers} signUpMembersIsError={signUpMembers.isError && notificationSignUpMembersError} NotificationSignUpMembersError={this.NotificationSignUpMembersError}/>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = ({ signUpMembers }) => {
  return {
    signUpMembers,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    createAccount: (userData) => dispatch(fetchSignUpMembersAction(userData)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpMembers)



// WEBPACK FOOTER //
// ./src/containers/SignUpMembers/index.js